import { all, call, put, takeEvery } from "redux-saga/effects";
import { actionTypes as dashboardActionTypes } from "./reducer";
import {
  getColdLead as getColdLeadService,
  getDataMonitoring as getDataMonitoringService,
  getProductivity as getProductivityService,
  getReceivableCommissions as getReceivableCommissionsService,
  getReleasedCommissions as getReleasedCommissionsService,
  getQualifiedCommissions as getQualifiedCommissionsService,
  getSchedules as getSchedulesService,
  createSchedule as createScheduleService,
  updateSchedule as updateScheduleService,
  markAsDone as markAsDoneService,
  deleteSchedule as deleteScheduleService,
  searchForUser as searchForUserService,
  postUserInformation as postUserInformationService,
  getUserInformation as getUserInformationService,
  postPurchaseJourney as postPurchaseJourneyService,
  getPurchaseJourney as getPurchaseJourneyService,
  postCustomerAttachments as postCustomerAttachmentsService,
  getAttachments as getAttachmentsService,
  postClientSignature as postClientSignatureService,
  getUserInformationFromSap as getUserInformationFromSapService,
  getClientSignature as getClientSignatureService,
  getReservationDetails as getReservationDetailsService,
  getBookingList as getBookingListService,
  submitBookingStatus as submitBookingStatusService,
  postLeadForm as postLeadFormService,
  getBrands as getBrandsService,
  getLead as getLeadService,
  getBuyerHistory as getBuyerHistoryService,
  getLeadProfile as getLeadProfileService,
  postObservation as postObservationService,
  getSapBookingList as getSapBookingListService,
  getSellerGroup as getSellerGroupService,
  getTransferRequest as getTransferRequestService,
  postTransferRequest as postTransferRequestService,
  getNationalities as getNationalitiesService,
  postLeadSignature as postLeadSignatureService,
  getLeadBuyer as getLeadBuyerService,
  getRetention as getRetentionService,
  claimOwnership as claimOwnershipService,
  postRequestOwnershipExtension as postRequestOwnershipExtensionService,
  postRequestSubmissionExtension as postRequestSubmissionExtensionService,
  getLeadRenewal as getLeadRenewalService,
  postLeadRenewal as postLeadRenewalService,
  postEPayment as postEPaymentService
} from "./service";
import processAction from "../../utils/processAction";

function* getColdLead(action) {
  yield processAction({
    ...action,
    service: getColdLeadService,
    success: dashboardActionTypes.GET_COLD_LEAD_SUCCESS,
    failed: dashboardActionTypes.GET_COLD_LEAD_FAILED
  });
}
function* getDataMonitoring(action) {
  yield processAction({
    ...action,
    service: getDataMonitoringService,
    success: dashboardActionTypes.GET_DATA_MONITORING_SUCCESS,
    failed: dashboardActionTypes.GET_DATA_MONITORING_FAILED
  });
}

function* getSchedules(action) {
  yield processAction({
    ...action,
    service: getSchedulesService,
    success: dashboardActionTypes.GET_SCHEDULES_SUCCESS,
    failed: dashboardActionTypes.GET_SCHEDULES_FAILED
  });
}

function* createSchedule(action) {
  const { params, onSuccess, onFailed } = action;

  try {
    const payload = yield call(createScheduleService, params);

    yield put({
      type: dashboardActionTypes.CREATE_SCHEDULE_SUCCESS,
      payload
    });

    onSuccess();
  } catch (error) {
    yield put({
      type: dashboardActionTypes.CREATE_SCHEDULE_FAILED,
      error
    });

    onFailed();

    throw new Error("Sap Error");
  }
}

function* updateSchedule(action) {
  const { params, onSuccess, onFailed } = action;

  try {
    const payload = yield call(updateScheduleService, params);

    yield put({
      type: dashboardActionTypes.UPDATE_SCHEDULE_SUCCESS,
      scheduleId: params.scheduleId,
      payload
    });

    onSuccess();
  } catch (error) {
    yield put({
      type: dashboardActionTypes.UPDATE_SCHEDULE_FAILED,
      error
    });

    onFailed();

    throw new Error("Sap Error");
  }
}

function* deleteSchedule(action) {
  const { params, onSuccess, onFailed } = action;

  try {
    yield call(deleteScheduleService, params);

    yield put({
      type: dashboardActionTypes.DELETE_SCHEDULE_SUCCESS,
      scheduleId: params.scheduleId
    });

    onSuccess();
  } catch (error) {
    yield put({
      type: dashboardActionTypes.DELETE_SCHEDULE_FAILED,
      error
    });

    onFailed();

    throw new Error("Sap Error");
  }
}

function* markAsDone(action) {
  yield processAction({
    ...action,
    service: markAsDoneService,
    success: dashboardActionTypes.DONE_SCHEDULE_SUCCESS,
    failed: dashboardActionTypes.DONE_SCHEDULE_FAILED
  });
}

function* getProductivity(action) {
  yield processAction({
    ...action,
    service: getProductivityService,
    success: dashboardActionTypes.GET_PRODUCTIVITY_SUCCESS,
    failed: dashboardActionTypes.GET_PRODUCTIVITY_FAILED
  });
}

function* getCommissions(action) {
  const { params } = action;
  // console.log(params, "CHECKING");

  try {
    console.log(action, "CHECKING");
    const [
      releasedCommissions,
      receivableCommissions,
      qualifiedCommissions
    ] = yield all([
      call(getReleasedCommissionsService, params),
      call(getReceivableCommissionsService, params),
      call(getQualifiedCommissionsService, params)
    ]);

    yield put({
      type: dashboardActionTypes.GET_COMMISSIONS_SUCCESS,
      releasedCommissions,
      receivableCommissions,
      qualifiedCommissions
    });
  } catch (error) {
    yield put({
      type: dashboardActionTypes.GET_COMMISSIONS_FAILED,
      error
    });
  }
}

function* getReleasedCommissions(action) {
  yield processAction({
    ...action,
    service: getReleasedCommissionsService,
    success: dashboardActionTypes.GET_RELEASED_COMMISSIONS_SUCCESS,
    failed: dashboardActionTypes.GET_RELEASED_COMMISSIONS_FAILED
  });
}

function* getReceivableCommissions(action) {
  yield processAction({
    ...action,
    service: getReceivableCommissionsService,
    success: dashboardActionTypes.GET_RECEIVABLE_COMMISSIONS_SUCCESS,
    failed: dashboardActionTypes.GET_RECEIVABLE_COMMISSIONS_FAILED
  });
}

function* getQualifiedCommissions(action) {
  yield processAction({
    ...action,
    service: getQualifiedCommissionsService,
    success: dashboardActionTypes.GET_QUALIFIED_COMMISSIONS_SUCCESS,
    failed: dashboardActionTypes.GET_QUALIFIED_COMMISSIONS_FAILED
  });
}

function* searchForBuyer(action) {
  yield processAction({
    ...action,
    service: searchForUserService,
    success: dashboardActionTypes.BUYER_SEARCH_SUCCESS,
    failed: dashboardActionTypes.BUYER_SEARCH_FAILED
  });
}

function* searchForSpouse(action) {
  yield processAction({
    ...action,
    service: searchForUserService,
    success: dashboardActionTypes.SPOUSE_SEARCH_SUCCESS,
    failed: dashboardActionTypes.SPOUSE_SEARCH_FAILED
  });
}

function* searchForCoBuyer(action) {
  yield processAction({
    ...action,
    service: searchForUserService,
    success: dashboardActionTypes.CO_BUYER_SEARCH_SUCCESS,
    failed: dashboardActionTypes.CO_BUYER_SEARCH_FAILED
  });
}

function* postBuyerInformation(action) {
  yield processAction({
    ...action,
    service: postUserInformationService,
    success: dashboardActionTypes.POST_PERSONAL_INFORMATION_SUCCESS,
    failed: dashboardActionTypes.POST_PERSONAL_INFORMATION_FAILED
  });
}

function* getUserInformation(action) {
  yield processAction({
    ...action,
    service: getUserInformationService,
    success: dashboardActionTypes.GET_USER_INFORMATION_SUCCESS,
    failed: dashboardActionTypes.GET_USER_INFORMATION_FAILED
  });
}

function* postPurchaseJourney(action) {
  yield processAction({
    ...action,
    service: postPurchaseJourneyService,
    success: dashboardActionTypes.POST_PURCHASE_JOURNEY_SUCCESS,
    failed: dashboardActionTypes.POST_PURCHASE_JOURNEY_FAILED
  });
}

function* getPurchaseJourney(action) {
  yield processAction({
    ...action,
    service: getPurchaseJourneyService,
    success: dashboardActionTypes.GET_PURCHASE_JOURNEY_SUCCESS,
    failed: dashboardActionTypes.GET_PURCHASE_JOURNEY_FAILED
  });
}

function* postClientAttachment(action) {
  yield processAction({
    ...action,
    service: postCustomerAttachmentsService,
    success: dashboardActionTypes.POST_ATTACHMENT_SUCCESS,
    failed: dashboardActionTypes.POST_ATTACHMENT_FAILED
  });
}

function* getAttachments(action) {
  yield processAction({
    ...action,
    service: getAttachmentsService,
    success: dashboardActionTypes.GET_ATTACHMENTS_SUCCESS,
    failed: dashboardActionTypes.GET_ATTACHMENTS_FAILED
  });
}

function* postClientSignature(action) {
  yield processAction({
    ...action,
    service: postClientSignatureService,
    success: dashboardActionTypes.POST_SIGNATURE_SUCCESS,
    failed: dashboardActionTypes.POST_SIGNATURE_FAILED
  });
}

function* getUserInfoSap(action) {
  yield processAction({
    ...action,
    service: getUserInformationFromSapService,
    success: dashboardActionTypes.GET_USER_INFO_SAP_SUCCESS,
    failed: dashboardActionTypes.GET_USER_INFO_SAP_FAILED
  });
}

function* getClientSignature(action) {
  yield processAction({
    ...action,
    service: getClientSignatureService,
    success: dashboardActionTypes.GET_SIGNATURE_SUCCESS,
    failed: dashboardActionTypes.GET_SIGNATURE_FAILED
  });
}

function* getReservationDetails(action) {
  yield processAction({
    ...action,
    service: getReservationDetailsService,
    success: dashboardActionTypes.GET_RESERVATION_DETAIL_SUCCESS,
    failed: dashboardActionTypes.GET_RESERVATION_DETAIL_FAILED
  });
}

function* getBookingList(action) {
  yield processAction({
    ...action,
    service: getBookingListService,
    success: dashboardActionTypes.GET_BOOKING_LIST_SUCCESS,
    failed: dashboardActionTypes.GET_BOOKING_LIST_FAILED
  });
}

function* submitReservationStatus(action) {
  yield processAction({
    ...action,
    service: submitBookingStatusService,
    success: dashboardActionTypes.SUBMIT_BOOKING_STATUS_SUCCESS,
    failed: dashboardActionTypes.SUBMIT_BOOKING_STATUS_FAILED
  });
}

function* getAllUserInfo(action) {
  yield processAction({
    ...action,
    service: getUserInformationService,
    success: dashboardActionTypes.GET_ALL_USER_INFO_SUCCESS,
    failed: dashboardActionTypes.GET_ALL_USER_INFO_FAILED
  });
}

function* postLeadForm(action) {
  // yield processAction({
  //   ...action,
  //   service: postLeadFormService,
  //   success: dashboardActionTypes.POST_LEAD_SUCCESS,
  //   failed: dashboardActionTypes.POST_LEAD_FAILED
  // });
  const { params, onSuccess, onFailed } = action;

  try {
    const payload = yield call(postLeadFormService, params);

    yield put({
      type: dashboardActionTypes.POST_LEAD_SUCCESS,
      payload
    });

    // onSuccess();
  } catch (error) {
    yield put({
      type: dashboardActionTypes.POST_LEAD_FAILED,
      error: error
    });

    // onFailed();

    // throw new Error("Sap Error");
  }
}

function* getBrands(action) {
  yield processAction({
    ...action,
    service: getBrandsService,
    success: dashboardActionTypes.GET_BRANDS_SUCCESS,
    failed: dashboardActionTypes.GET_BRANDS_FAILED
  });
}

function* getLeadProfile(action) {
  yield processAction({
    ...action,
    service: getLeadProfileService,
    success: dashboardActionTypes.GET_LEAD_PROFILE_SUCCESS,
    failed: dashboardActionTypes.GET_LEAD_PROFILE_FAILED
  });
}

function* getLead(action) {
  yield processAction({
    ...action,
    service: getLeadService,
    success: dashboardActionTypes.GET_LEAD_SUCCESS,
    failed: dashboardActionTypes.GET_LEAD_FAILED
  });
}

function* getBuyerHistory(action) {
  yield processAction({
    ...action,
    service: getBuyerHistoryService,
    success: dashboardActionTypes.GET_BUYER_HISTORY_SUCCESS,
    failed: dashboardActionTypes.GET_BUYER_HISTORY_FAILED
  });
}

function* createObservation(action) {
  yield processAction({
    ...action,
    service: postObservationService,
    success: dashboardActionTypes.POST_OBSERVATION_SUCCESS,
    failed: dashboardActionTypes.POST_OBSERVATION_FAILED
  });
}

function* getSapBookingList(action) {
  yield processAction({
    ...action,
    service: getSapBookingListService,
    success: dashboardActionTypes.GET_SAP_BOOKING_LIST_SUCCESS,
    failed: dashboardActionTypes.GET_SAP_BOOKING_LIST_FAILED
  });
}

function* getSellerGroup(action) {
  yield processAction({
    ...action,
    service: getSellerGroupService,
    success: dashboardActionTypes.GET_SELLER_GROUP_SUCCESS,
    failed: dashboardActionTypes.GET_SELLER_GROUP_FAILED
  });
}

function* getTransferRequest(action) {
  yield processAction({
    ...action,
    service: getTransferRequestService,
    success: dashboardActionTypes.GET_TRANSFER_REQUEST_SUCCESS,
    failed: dashboardActionTypes.GET_TRANSFER_REQUEST_FAILED
  });
}

function* postTransferRequest(action) {
  yield processAction({
    ...action,
    service: postTransferRequestService,
    success: dashboardActionTypes.POST_TRANSFER_REQUEST_SUCCESS,
    failed: dashboardActionTypes.POST_TRANSFER_REQUEST_FAILED
  });
}

function* getNationality(action) {
  yield processAction({
    ...action,
    service: getNationalitiesService,
    success: dashboardActionTypes.GET_NATIONALITY_SUCCESS,
    failed: dashboardActionTypes.GET_NATIONALITY_FAILED
  });
}

function* postLeadSignature(action) {
  yield processAction({
    ...action,
    service: postLeadSignatureService,
    success: dashboardActionTypes.POST_LEAD_SIGNATURE_SUCCESS,
    failed: dashboardActionTypes.POST_LEAD_SIGNATURE_FAILED
  });
}

function* getLeadBuyer(action) {
  yield processAction({
    ...action,
    service: getLeadBuyerService,
    success: dashboardActionTypes.GET_LEAD_BUYER_LIST_SUCCESS,
    failed: dashboardActionTypes.GET_LEAD_BUYER_LIST_FAILED
  });
}

function* getRetention(action) {
  yield processAction({
    ...action,
    service: getRetentionService,
    success: dashboardActionTypes.GET_RETENTION_SUCCESS,
    failed: dashboardActionTypes.GET_RETENTION_FAILED
  });
}

function* postClaimOwnershipBySeller(action) {
  yield processAction({
    ...action,
    service: claimOwnershipService,
    success: dashboardActionTypes.POST_OWNERSHIP_SUCCESS,
    failed: dashboardActionTypes.POST_OWNERSHIP_FAILED
  });
}

function* postRequestOwnershipExtension(action) {
  yield processAction({
    ...action,
    service: postRequestOwnershipExtensionService,
    success: dashboardActionTypes.POST_REQUEST_OWNERSHIP_EXTENSION_SUCCESS,
    failed: dashboardActionTypes.POST_REQUEST_OWNERSHIP_EXTENSION_FAILED
  });
}

function* postRequestSubmissionExtension(action) {
  yield processAction({
    ...action,
    service: postRequestSubmissionExtensionService,
    success: dashboardActionTypes.POST_REQUEST_SUBMISSION_EXTENSION_SUCCESS,
    failed: dashboardActionTypes.POST_REQUEST_SUBMISSION_EXTENSION_FAILED
  });
}

function* getLeadRenewal(action) {
  yield processAction({
    ...action,
    service: getLeadRenewalService,
    success: dashboardActionTypes.GET_LEAD_RENEWAL_SUCCESS,
    failed: dashboardActionTypes.GET_LEAD_RENEWAL_FAILED
  });
}

function* postLeadRenewal(action) {
  yield processAction({
    ...action,
    service: postLeadRenewalService,
    success: dashboardActionTypes.POST_LEAD_RENEWAL_SUCCESS,
    failed: dashboardActionTypes.POST_LEAD_RENEWAL_FAILED
  });
}

function* postEPayment(action) {
  yield processAction({
    ...action,
    service: postEPaymentService,
    success: dashboardActionTypes.POST_E_PAYMENT_SUCCESS,
    failed: dashboardActionTypes.POST_E_PAYMENT_FAILED
  });
}

function* watcher() {
  yield all([
    takeEvery(dashboardActionTypes.DONE_SCHEDULE, markAsDone),
    takeEvery(dashboardActionTypes.GET_PRODUCTIVITY, getProductivity),
    takeEvery(
      dashboardActionTypes.GET_RELEASED_COMMISSIONS,
      getReleasedCommissions
    ),
    takeEvery(
      dashboardActionTypes.GET_COLD_LEAD,
      getColdLead
    ),
    takeEvery(
      dashboardActionTypes.GET_DATA_MONITORING,
      getDataMonitoring
    ),
    takeEvery(
      dashboardActionTypes.GET_RECEIVABLE_COMMISSIONS,
      getReceivableCommissions
    ),
    takeEvery(
      dashboardActionTypes.GET_QUALIFIED_COMMISSIONS,
      getQualifiedCommissions
    ),
    takeEvery(dashboardActionTypes.GET_COMMISSIONS, getCommissions),
    takeEvery(dashboardActionTypes.GET_SCHEDULES, getSchedules),
    takeEvery(dashboardActionTypes.CREATE_SCHEDULE, createSchedule),
    takeEvery(dashboardActionTypes.UPDATE_SCHEDULE, updateSchedule),
    takeEvery(dashboardActionTypes.DELETE_SCHEDULE, deleteSchedule),
    takeEvery(dashboardActionTypes.BUYER_SEARCH, searchForBuyer),
    takeEvery(dashboardActionTypes.SPOUSE_SEARCH, searchForSpouse),
    takeEvery(dashboardActionTypes.CO_BUYER_SEARCH, searchForCoBuyer),
    takeEvery(
      dashboardActionTypes.POST_PERSONAL_INFORMATION,
      postBuyerInformation
    ),
    takeEvery(dashboardActionTypes.GET_USER_INFORMATION, getUserInformation),
    takeEvery(dashboardActionTypes.POST_PURCHASE_JOURNEY, postPurchaseJourney),
    takeEvery(dashboardActionTypes.GET_PURCHASE_JOURNEY, getPurchaseJourney),
    takeEvery(dashboardActionTypes.POST_ATTACHMENT, postClientAttachment),
    takeEvery(dashboardActionTypes.GET_ATTACHMENTS, getAttachments),
    takeEvery(dashboardActionTypes.POST_SIGNATURE, postClientSignature),
    takeEvery(dashboardActionTypes.GET_USER_INFO_SAP, getUserInfoSap),
    takeEvery(dashboardActionTypes.GET_SIGNATURE, getClientSignature),
    takeEvery(
      dashboardActionTypes.GET_RESERVATION_DETAIL,
      getReservationDetails
    ),
    takeEvery(dashboardActionTypes.GET_BOOKING_LIST, getBookingList),
    takeEvery(
      dashboardActionTypes.SUBMIT_BOOKING_STATUS,
      submitReservationStatus
    ),
    takeEvery(dashboardActionTypes.GET_ALL_USER_INFO, getAllUserInfo),
    takeEvery(dashboardActionTypes.POST_LEAD, postLeadForm),
    takeEvery(dashboardActionTypes.GET_BRANDS, getBrands),
    takeEvery(dashboardActionTypes.GET_LEAD, getLead),
    takeEvery(dashboardActionTypes.GET_BUYER_HISTORY, getBuyerHistory),
    takeEvery(dashboardActionTypes.GET_LEAD_PROFILE, getLeadProfile),
    takeEvery(dashboardActionTypes.POST_OBSERVATION, createObservation),
    takeEvery(dashboardActionTypes.GET_SAP_BOOKING_LIST, getSapBookingList),
    takeEvery(dashboardActionTypes.GET_SELLER_GROUP, getSellerGroup),
    takeEvery(dashboardActionTypes.GET_TRANSFER_REQUEST, getTransferRequest),
    takeEvery(dashboardActionTypes.POST_TRANSFER_REQUEST, postTransferRequest),
    takeEvery(dashboardActionTypes.GET_NATIONALITY, getNationality),
    takeEvery(dashboardActionTypes.POST_LEAD_SIGNATURE, postLeadSignature),
    takeEvery(dashboardActionTypes.GET_LEAD_BUYER_LIST, getLeadBuyer),
    takeEvery(dashboardActionTypes.GET_RETENTION, getRetention),
    takeEvery(dashboardActionTypes.POST_OWNERSHIP, postClaimOwnershipBySeller),
    takeEvery(
      dashboardActionTypes.POST_REQUEST_OWNERSHIP_EXTENSION,
      postRequestOwnershipExtension
    ),
    takeEvery(
      dashboardActionTypes.POST_REQUEST_SUBMISSION_EXTENSION,
      postRequestSubmissionExtension
    ),
    takeEvery(dashboardActionTypes.GET_LEAD_RENEWAL, getLeadRenewal),
    takeEvery(dashboardActionTypes.POST_LEAD_RENEWAL, postLeadRenewal),
    takeEvery(dashboardActionTypes.POST_E_PAYMENT, postEPayment)
  ]);
}

export default [watcher()];
